class Element {
  id: number = 0;
  code: string = "";
  name: string = "";
  notes: string = "";

  constructor(data: Partial<Element>) {
    this.id = data.id || 0;
    this.code = data.code || "";
    this.name = data.name || "";
    this.notes = data.notes || "";
  }
}

export default Element;
